import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'phoneFormat',
    standalone: true,
})
export class PhoneFormatPipe implements PipeTransform {
    transform(value: string | number): string {
        if (!value) return '';

        const s = value.toString();

        if (s.length === 11) {
            return `+${s[0]} (${s.slice(1, 4)}) ${s.slice(4, 7)}-${s.slice(7)}`;
        } else if (s.length === 10) {
            return `(${s.slice(0, 3)}) ${s.slice(3, 6)}-${s.slice(6)}`;
        }

        return s;
    }
}
